<template>
  <div class="bookmarks">
    <h2>Your Bookmarks</h2>
    <div class="list">
      <div
          @click="$emit('selected', Number(item.pageNumber))"
          class="bookmark-item"
          v-for="(item, index) in sortedBookmarks">
        <div class="page-number">Page {{ item.pageNumber }}</div>
        <input type="text" v-model="item.title" class="title">
      </div>
      <div v-if="bookmarks.length === 0" class="empty">
        Empty
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bookmarks",
  props: ['bookmarks'],
  data() {
    return {}
  },
  computed: {
    sortedBookmarks() {
      return this.bookmarks
          .sort( (prev, next) => prev.pageNumber > next.pageNumber ? 1 : -1 )
    }
  }
}
</script>

<style lang="scss">
.bookmarks {
  width: 20%;
  padding-left: 20px;
  padding-top: 10px;
  margin-left: auto;
  margin-right: 10px;
  .list {
    .bookmark-item {
      border: 1px solid $mainGreen;
      border-radius: 5px;
      background-color: #FEFEFE;
      margin-bottom: 10px;
      padding: 10px;
      min-width: 230px;
      cursor: pointer;
      .page-number {
        font-weight: bold;
        font-size: 10px;
        line-height: 12px;
        color: #BDBDBD;
      }
      .title {
        font-size: 16px;
        line-height: 19px;
        color: #3C3C3C;
        background-color: transparent;
        outline: none;
        border: none;
      }
    }
  }
}
</style>